import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from '../../../../shared/ui/Card'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './BenefitsSection.module.scss'

type Benefit = { title: string; desc: string }

export const BenefitsSection: React.FC = () => {
    const { t } = useTranslation()
    const items = t('benefits.items', { returnObjects: true }) as Benefit[]

    return (
        <PageSection
            title={t('benefits.title')}
            align="start"
            style={{ backgroundColor: 'var(--bg-base)' }}
        >
            <div className={cls.grid}>
                {items.map((b, idx) => (
                    <Card key={idx}>
                        <p className={cls.title}>{b.title}</p>
                        <p className={cls.desc}>{b.desc}</p>
                    </Card>
                ))}
            </div>
        </PageSection>
    )
}

export default BenefitsSection

